import { popupLogin } from "@/components/common/popups";
import { jsUrl } from "@/const";
import { openLink } from "@/handle/route";
import { useUserCreate } from "@/store/User";
export function getUpdateTime(timeStep) {
  // 创建 UTC 时间的 Date 对象
  const utcDate = new Date(timeStep * 1000);
  // 使用 Intl.DateTimeFormat 来获取 EST 时区的格式化日期
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  // 格式化日期
  const estFormattedDate = formatter.format(utcDate);
  return estFormattedDate;
}
export function getDetailUrl(urlName, language) {
  if (language === "en") {
    return "".concat(jsUrl, "/blog/").concat(urlName, ".html");
  }
  return "".concat(jsUrl, "/").concat(language, "/blog/").concat(urlName, ".html");
}
export function notLoginHandle() {
  if (!!useUserCreate.getState().userState.userId) {
    openLink("");
  } else {
    popupLogin();
  }
}